import * as jose from "jose";

const getHours = (date: string, hourSuffix = "", minutesSuffix = "") => {
  const hours = new Date(date)
    .toLocaleTimeString(navigator.language, { hour: "2-digit", minute: "2-digit" })
    .split(":");
  return `${hours[0]}${hourSuffix}${hours[1]}${minutesSuffix}`;
};

const getDate = (date: string, formatOptions?: any) => {
  const createdDate = new Date(date);
  const options = formatOptions || { weekday: "short", year: "numeric", month: "numeric", day: "numeric" };
  let formattedCreatedDate = createdDate.toLocaleDateString("pt-br", options).replace(".", "");
  formattedCreatedDate = formattedCreatedDate.charAt(0).toUpperCase() + formattedCreatedDate.slice(1);
  return formattedCreatedDate;
};

const getFlightDuration = (departure: string, arrival: string) => {
  const timeStart = new Date(departure).getTime();
  const timeEnd = new Date(arrival).getTime();
  const hourDiff = timeEnd - timeStart;
  const minDiff = hourDiff / 60 / 1000;
  return timeConvert(minDiff);
};

const timeConvert = (min: number) => {
  const num = min;
  const hours = num / 60;
  const rHours = Math.floor(hours);
  const minutes = (hours - rHours) * 60;
  const rMinutes = Math.round(minutes);
  return `${rHours}h${rMinutes}min`;
};
const getMemberNumber = (token: string | null) => {
  if (token) {
    try {
      return jose.decodeJwt(token).sub?.split("|")[2];
    } catch (e) {
      console.error("Invalid JWT", e);
    }
  }
  return "";
};

export { getHours, getDate, getFlightDuration, getMemberNumber };
